<template>
  <div class="Messages" :class="type">
    <svg
      v-svg
      v-if="svgName !== ''"
      :symbol="svgName"
      size="0 0 24 24"
      role="presentation"
      :class="'icon--inline Icon-' + svgName"
    ></svg>
    <span v-if="text !== ''" v-html="text"></span>
  </div>
</template>

<script>
import "@/components/Messages/Messages.scss";

export default {
  name: "Messages",

  props: {
    type: {
      type: String,
      default: "info",
      required: false,
    },

    text: {
      type: String,
      required: false,
    },

    svgName: {
      type: String,
      required: false,
      default: "",
    },
  },
};
</script>
